import { useEffect, useState } from "react";
import { contextApp } from "../App";
import { firebase_app } from "../firebase";
import { FormDynamic } from "./resources/FormDynamic";
import { Utils } from "./Utils";

export function useForm(codeform:string,history:any,changeTheme:boolean = false){
  
    const [form,setForm] = useState<FormDynamic>();
    useEffect(()=>{
        firebase_app.firestore().collection("forms-dynamic").doc(codeform+"").get().then((data)=>{
          
           
            if(data && data.data()){ 
          
                
                let f:FormDynamic = data.data() as FormDynamic;
                if(Utils.checkForm(f)){
                    f.params.map( p => p.value = "")
                    f.params =  f.params.filter( p => p.enable)
                    f.idForm = codeform
                    document.title = f.title
                    if(f.backgroundColor && f.fontColor && changeTheme){
                       
                        contextApp.changeTheme(f.fontColor+"",f.backgroundColor+"")
                    }
                    setForm(f);
                }else{
          
                    history.push("/404")
                }

            }else{
                history.push("/404")
            }
        })
    },[codeform,history,changeTheme])

    return{
        form,setForm 
    }
}